module.exports = __webpack_public_path__ + "static/439c5962-f9fe-4eaf-a1f6-f41d42edba75-d9dbca36b8e3ee6bd7f49028724ec507.woff";